import BaseModel from '../core/BaseModel'
export default class OrganizationAccountModel extends BaseModel {
    constructor() {
        super({ 
                name: "organization_account",
                tableName: 'core_organization_account',
                display_key: 'id'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: 'organization_id',
                display: false
            },
        },)
    }

}